import TextChallenge from './TextChallenge';

// Extension points of the page, keyed by the contract of the engine (HIA-BUG-20260929-7):
//   - challengeRenderers by `contentType` (a future image family adds e.g. 'image/png');
//   - answerKinds by `solution.answer.kind` (how to write the expected answer in clear);
//   - highlight targets by `target.kind` live in indexRoles.js.
// An unknown type falls back to a message, never to an exception; the validation stays available.
export const challengeRenderers = Object.freeze({
    'text/plain': TextChallenge,
});

export const answerKinds = Object.freeze({
    TEXT: (answer) => (typeof answer.value === 'string' ? answer.value : null),
});

export const rendererFor = (contentType) =>
    (typeof contentType === 'string' && challengeRenderers[contentType.split(';')[0].trim()]) || null;

export const answerText = (solution) => {
    const answer = solution && solution.answer;
    const read = answer && answerKinds[answer.kind];
    return read ? read(answer) : null;
};
